import type { ArgusInstanceDetailResponse, ArgusInstanceResponse } from "../../types/argus";
import { useApiQuery } from "../use-api-query";

interface UseArgusInstanceOptions {
  /**
   * Override the default 2s polling interval. Argus defaults to 5s polling
   * when consumed by the connection provider — boot transitions are slow
   * enough that a tighter interval just burns requests.
   */
  refetchInterval?: number;
}

export function useArgusInstance(
  instanceId: string | undefined,
  options?: UseArgusInstanceOptions,
) {
  const query = useApiQuery<ArgusInstanceDetailResponse>(`/client/argus/instances/${instanceId}`, {
    enabled: !!instanceId,
    refetchInterval: options?.refetchInterval ?? 2_000,
  });

  return {
    ...query,
    instance: query.data?.data as ArgusInstanceResponse | undefined,
  };
}
